import React from 'react';
import { Typography, Grid } from '@mui/material';

export default function ModePaiement() {

	return (
		<Grid container direction="row" justifyContent="center" align="center" mt={3}>
			<Grid item xs={12} my={2}>
				<Typography component="h4" sx={{ mb:2, mt:3, color: '#004afe', fontSize: { xs: 22, sm: 22, md: 22, lg: 28 }, fontWeight: 400, textAlign: 'center' }} >
					Modes de paiement supportés
				</Typography>
			</Grid>
			<Grid container direction="row" justifyContent="center" align="center">
				<Grid item>
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-cb.jpg'} alt="Paiement par Carte Bancaire" width={'14%'} />
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-visa.jpg'} alt="Paiement avec carte VISA" width={'14%'} />
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-mastercard.jpg'} alt="Paiement avec carte Mastercard" width={'14%'} />
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-paypal.jpg'} alt="Paiement avec compte PayPal" width={'14%'} />
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-gpay.jpg'} alt="Paiement avec compte Google Pay" width={'14%'} />
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-applepay.jpg'} alt="Paiement avec compte Apple Pay" width={'14%'} />
					<img src={process.env.REACT_APP_PATH_IMAGES + '/payment/payment-amex.jpg'} alt="Paiement avec carte American Express" width={'14%'} />
				</Grid>
			</Grid>
		</Grid>
	);
}